module.exports = __webpack_public_path__ + "static/Meditopia-01f71208bfb72b47259be8317256b985.jpg";